import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";

export const GET_COURT_RECORDING_VIDEO_URL_QUERY_KEY = (id: string) => ['court-recordings', id, 'video-url'];

export const useGetCourtRecordingVideoUrl = (id: string, enabled: boolean) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_COURT_RECORDING_VIDEO_URL_QUERY_KEY(id),
        queryFn: () => client.fetchApi<{ url: string }, {}>({
            endpoint: `court-recordings/${id}/video-url`,
            method: 'GET',
        }),
        enabled: Boolean(id) && enabled,
        staleTime: 60 * 60 * 1000, // 1h (SAS token valid for 2h)
    });
};
